module.exports = __webpack_public_path__ + "static/media/stars-less-3840.c968446e.webp";